import { memo } from 'react';

import Button from 'devextreme-react/button';
import { TagBox, Tooltip, ContextMenu, Toolbar } from 'devextreme-react';
import { resButtonsSelectAll, resButtonOportunity, resButtonsClear, resButtonsPin, resButtonsUnvalid, resGridStatus3, resButtonsRetransm, deleteIcon, resButtonsPreview, resButtonsPrint, resButtonsMail, ordBarcode, resButtonRefresh, Pin, UnPin, whatsapp } from '../../../../../images/icons';
import { ordMuestras } from '../../../../../images/icons';
import { LIS_States } from '../../../../../utils/systemTypes';
import { Item } from 'devextreme-react/toolbar';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { setPanelPined, setPanelVisible } from '../../../../../contexts/slices/orders';
import { shallowEqual } from 'react-redux';

type Props = {
  selectedStates: number[];
  onSelectAll: () => void;
  onShowSamples: () => void;
  onOpportunity: () => void;
  onClear: () => void;
  onPinWhite: () => void;
  onInvalidate: () => void;
  onValidate: () => void;
  onResend: () => void;
  onDelete: () => void;
  onPreview: () => void;
  onPrint: () => void;
  onPrintSelected: () => void;
  onSendMail: () => void;
  onSendMailSelected: () => void;
  onSendWhatsApp: () => void;
  onSendWhatsAppSelected: () => void;
  onPrintBarcodes: () => void;
  onPrintBarcodesSelected: () => void;
  onRefresh: () => void;
  onFilterChange: (e: number[]) => void;
  permisos: {
    Prm_Conf_Campos_Diseno: boolean;
    modeEditor: boolean;
    Prm_ResValidar: boolean;
    Prm_Res_Retransmitir: boolean;
    Prm_Res_DelAn: boolean;
    Prm_ResImprimir: boolean;
    ModuleBarcode: boolean;
    ModuleEmail: boolean;
    ModuleWhatsApp: boolean;
    Prm_Res_Mail: boolean;
    Prm_Res_WhatsApp: boolean;
  };
};

export const ResultsToolbar = memo(({ selectedStates, onSelectAll, onShowSamples, onOpportunity, onClear, onPinWhite, onInvalidate, onValidate, onResend, onDelete, onPreview, onPrint, onPrintSelected, onSendMail, onSendMailSelected, onSendWhatsApp, onSendWhatsAppSelected, onPrintBarcodes, onPrintBarcodesSelected, onRefresh, onFilterChange, permisos }: Props) => {
  const { Prm_Conf_Campos_Diseno, modeEditor, Prm_ResValidar, Prm_Res_Retransmitir, Prm_Res_DelAn, Prm_ResImprimir, ModuleBarcode } = permisos;
  const panelVisible = useAppSelector((x) => x.globalOrders.PanelVisible, shallowEqual);
  const dispatch = useAppDispatch();
  const handlePanelClose = () => {
    dispatch(setPanelVisible(true));
    dispatch(setPanelPined(false));
  };

  return (
    <Toolbar>
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='SelectAllBtn' icon={resButtonsSelectAll} text='Seleccionar todo' onClick={onSelectAll} stylingMode='text' />
        <Tooltip target={'#SelectAllBtn'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Seleccionar todo
        </Tooltip>
      </Item>
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='ShowSamplesBtn' icon={ordMuestras} text='Muestras' onClick={onShowSamples} stylingMode='text' />
        <Tooltip target={'#ShowSamplesBtn'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Ver muestras
        </Tooltip>
      </Item>
      <Item location='before' locateInMenu='auto'>
        <div className='separator' />
      </Item>
      {Prm_Conf_Campos_Diseno && modeEditor && <Item location='before' />}
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='OpportunityBtn1' icon={resButtonOportunity} text='Oportunidad' stylingMode='text' onClick={onOpportunity} />
        <Tooltip target={'#OpportunityBtn1'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Oportunidad
        </Tooltip>
      </Item>
      <Item location='before' locateInMenu='auto'>
        <div className='separator' />
      </Item>
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='ClarearResultado' icon={resButtonsClear} text='Limpiar resultado' onClick={onClear} stylingMode='text' />
        <Tooltip target={'#ClarearResultado'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Limpiar resultados seleccionados
        </Tooltip>
      </Item>
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='FijarResultBlanco' icon={resButtonsPin} text='Marcar resultado en blanco' onClick={onPinWhite} stylingMode='text' />
        <Tooltip target={'#FijarResultBlanco'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Marcar resultado en blanco
        </Tooltip>
      </Item>
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='DesvalidarResult' icon={resButtonsUnvalid} text='Desvalidar resultado' onClick={onInvalidate} stylingMode='text' />
        <Tooltip target={'#DesvalidarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Desvalidar resultados seleccionados
        </Tooltip>
      </Item>
      <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton' visible={Prm_ResValidar}>
        <Button id='ValidarResult' icon={resGridStatus3} text='Validar resultado' onClick={onValidate} stylingMode='text' />
        <Tooltip target={'#ValidarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Validar resultados seleccionados
        </Tooltip>
      </Item>
      <Item visible={permisos.Prm_Res_Retransmitir} location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='RetransmitirResult' icon={resButtonsRetransm} text='Retransmitir resultado' onClick={onResend} stylingMode='text' />
        <Tooltip target={'#RetransmitirResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Retransmitir resultados seleccionados
        </Tooltip>
      </Item>

      <Item location='before' locateInMenu='auto' visible={Prm_Res_DelAn} showText='inMenu' widget='dxButton'>
        <Button id='EliminarAnalitoResult' icon={deleteIcon} text='Eliminar analito seleccionado' onClick={onDelete} stylingMode='text' />
        <Tooltip target={'#EliminarAnalitoResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Eliminar analitos seleccionados
        </Tooltip>
      </Item>
      <Item location='center'>
        <TagBox value={selectedStates} items={LIS_States} displayExpr='State' valueExpr='Value' placeholder='Estado' onValueChanged={(e) => onFilterChange(e.value)} showSelectionControls={true} showClearButton={true} applyValueMode='useButtons' width={200} stylingMode='outlined' maxDisplayedTags={1} />
      </Item>

      <Item location='after' locateInMenu='auto'>
        <div className='separator' />
      </Item>
      <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='PrevisualizarResult' icon={resButtonsPreview} text='Previsualizar resultados' onClick={onPreview} stylingMode='text' />
        <Tooltip target={'#PrevisualizarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Previsualizar resultados
        </Tooltip>
      </Item>
      <Item location='after' locateInMenu='auto' visible={Prm_ResImprimir} showText='inMenu' widget='dxButton'>
        <Button id='ImprimirResult' icon={resButtonsPrint} text='Imprimir resultados' stylingMode='text' onClick={onPrint} />
        <ContextMenu width={'auto'} target={'#ImprimirResult'} dataSource={[{ text: 'Imprimir estudios seleccionados', icon: resButtonsPrint }]} onItemClick={onPrintSelected} />
        <Tooltip target={'#ImprimirResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Imprimir resultados
        </Tooltip>
      </Item>
      <Item location='after' visible={permisos.ModuleEmail && permisos.Prm_Res_Mail} locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='EnviarResultMail' icon={resButtonsMail} text='Enviar resultados por correo' stylingMode='text' onClick={onSendMail} />
        <ContextMenu width={'auto'} target={'#EnviarResultMail'} dataSource={[{ text: 'Enviar estudios seleccionados', icon: resButtonsMail }]} onItemClick={onSendMailSelected} />
        <Tooltip target={'#EnviarResultMail'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Enviar resultados por correo
        </Tooltip>
      </Item>
      <Item location='after' visible={permisos.ModuleWhatsApp && permisos.Prm_Res_WhatsApp} locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='EnviarResultWhatsApp' icon={whatsapp} text='Enviar resultados por WhatsApp' stylingMode='text' onClick={onSendWhatsApp} />
        <ContextMenu width={'auto'} target={'#EnviarResultWhatsApp'} dataSource={[{ text: 'Enviar estudios seleccionados', icon: whatsapp }]} onItemClick={onSendWhatsAppSelected} />
        <Tooltip target={'#EnviarResultWhatsApp'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Enviar resultados por WhatsApp
        </Tooltip>
      </Item>
      <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton' visible={ModuleBarcode}>
        <Button id='ImprimirEtiquetasResult' icon={ordBarcode} text='Imprimir etiquetas' stylingMode='text' onClick={onPrintBarcodes} />
        <ContextMenu width={'auto'} target={'#ImprimirEtiquetasResult'} dataSource={[{ text: 'Imprimir estudios seleccionados', icon: ordBarcode }]} onItemClick={onPrintBarcodesSelected} />
        <Tooltip target={'#ImprimirEtiquetasResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Imprimir etiquetas para la orden
        </Tooltip>
      </Item>
      <Item location='after' locateInMenu='auto'>
        <div className='separator' />
      </Item>
      <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
        <Button id='RefrecarResult' icon={resButtonRefresh} text='Refresh' stylingMode='text' onClick={onRefresh} />
        <Tooltip target={'#RefrecarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          Refrescar datos
        </Tooltip>
      </Item>
      <Item location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
        <Button id='Showpanel' icon={panelVisible ? Pin : UnPin} text={panelVisible ? 'Panel Visible' : 'Panel oculto'} stylingMode='text' onClick={handlePanelClose} />
        <Tooltip target={'#Showpanel'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
          {panelVisible ? 'Ocultar panel' : 'Abrir panel'}
        </Tooltip>
      </Item>
      {Prm_Conf_Campos_Diseno && modeEditor && <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton' />}
    </Toolbar>
  );
});
